module.exports = __webpack_public_path__ + "static/media/Ship-Meraviglia-technogym_tcm.7ba6e6ce.webp";